import { ThemeProvider } from 'styled-components';
import { COMPONENT_CONFIG } from '@/brand-components';
import { useSelector } from '@/redux';

export default function MobileRewards() {
  const { slug } = useSelector((state) => state.app.organization.organization);
  const { webConfig } = useSelector((state) => state.app.cmsConfig);
  const REWARDS_TERMS_CONTENT = COMPONENT_CONFIG.MODAL_HOW_REWARDS_WORK[slug];
  return (
    <ThemeProvider theme={webConfig}>
      {REWARDS_TERMS_CONTENT && <REWARDS_TERMS_CONTENT />}
    </ThemeProvider>
  );
}
